export { useNewsDetail } from "./useNewsDetail";
export { useNewsSlider } from "./useNewsSlider";
export { useScrollDetection } from "./useScrollDetection";

